import { render } from "./About.vue?vue&type=template&id=3e54eb6a&scoped=true"
import script from "./About.vue?vue&type=script&lang=ts"
export * from "./About.vue?vue&type=script&lang=ts"

import "./About.vue?vue&type=style&index=0&id=3e54eb6a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3e54eb6a"

export default script